import { render, staticRenderFns } from "./ProductsImport.vue?vue&type=template&id=54a831c5&scoped=true&"
import script from "./ProductsImport.vue?vue&type=script&lang=js&"
export * from "./ProductsImport.vue?vue&type=script&lang=js&"
import style0 from "./ProductsImport.vue?vue&type=style&index=0&id=54a831c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a831c5",
  null
  
)

export default component.exports